/**
 * The glass "Reset" chip, top-right of a zoomed stage (spec 9.7). Shows the
 * zoom and returns to 1x. A material is right here: it floats over moving
 * video (MT-1). Caption 1 12/16; the visual is 28 tall, the target 44.
 */
export function ZoomResetChip({ scale, onReset, top = 8 }: { scale: number; onReset: () => void; top?: number }) {
  if (scale <= 1.01) return null;
  return (
    <button
      type="button"
      onClick={onReset}
      aria-label={`Zoom ${scale.toFixed(1)}x, reset to 1x`}
      /* Spec 15: the one glass style (.lve-glass) over the video. */
      className="absolute right-2 z-[24] h-7 px-2.5 rounded-full inline-flex items-center gap-1.5 text-[12px] leading-[16px] font-semibold text-white ios-press lve-glass after:absolute after:content-[''] after:-inset-y-2 after:inset-x-0"
      style={{ top }}
    >
      <span className="tabular-nums">{scale.toFixed(1)}×</span>
      <span>Reset</span>
    </button>
  );
}
